<template>
  <div>
    <vs-card>
      <div class="p-4">
        <div class="flex justify-between">
          <span class="col-span-2 md:col-span-1" style="font-weight: 700; font-size: 18px;">업체관리</span>
          <div class="flex gap-2">
            <vs-button v-if="getId && myInfo && (myInfo.can_manage_pending_user || myInfo.is_superuser)" color="secondary" type="border" @click="onClickRemove">업체삭제</vs-button>
            <vs-button color="secondary" type="border" @click="onClickClose">닫기</vs-button>
            <vs-button v-if="getId && editMode" color="secondary" type="border" @click="onClickCancel">취소</vs-button>
            <vs-button v-if="editMode && myInfo && (myInfo.can_manage_pending_user || myInfo.is_superuser)" color="secondary" @click="onClickSave">{{ getId ? '변경사항 저장' : '신규등록'}}</vs-button>
          </div>
        </div>
        <h5 class="my-4"><i class="dot"></i> 업체 정보</h5>
        <div class="grid-container">
          <input-form class="grid-item" label="사업장명">
            <multiselect
              class="w-full"
              v-model="company.fields"
              :options="fieldOptions"
              :multiple="true"
              label="field_name"
              track-by="id"
              placeholder="사업장을 선택해주세요."
            />
          </input-form>
        </div>

        <div class="grid-container mt-8">
          <input-form class="grid-item" label="업체명">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="업체명 입력"
                v-model="company.com_name"
              />
            </label>
          </input-form>

          <input-form class="grid-item gap-2" label="업체구분">
            <radio-group
              class="col-span-4 mb-2"
              flex
              :items="[{label: '직영', value: '직영'}, {label: '수급업체', value: '수급업체'}]"
              :row-count="2"
              v-model="company.com_type"
            />
          </input-form>

          <input-form class="grid-item" label="대표자">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="대표자 입력"
                v-model="company.com_ceo"
              />
            </label>
          </input-form>

          <input-form class="grid-item" label="사업자등록번호">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="사업자등록번호 입력"
                v-model="company.com_number"
                @input="formatBusinessNumber"
                :success="businessNumberSuccess"
                :danger="businessNumberDanger"
                :success-text="businessNumberSuccess ? '사용 가능한 사업자등록번호입니다.' : undefined"
                :danger-text="businessNumberDanger ? '이미 등록된 사업자등록번호입니다.' : undefined"
              />
            </label>
          </input-form>

          <input-form class="grid-item" label="사업자등록증">
            <file-uploader
              class="w-full"
              placeholder="파일을 업로드해주세요."
              v-model="사업자등록증" />
          </input-form>

          <input-form class="grid-item" label="주소">
            <address-field class="w-full" v-model="addressInfo" :visible-zip-code="false" />
          </input-form>

        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="업태">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="업태 입력"
                v-model="company.com_business_class"
              />
            </label>
          </input-form>

          <input-form class="grid-item" label="업종">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="업종 입력"
                v-model="company.com_business_type"
              />
            </label>
          </input-form>

          <input-form class="grid-item" label="담당자">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="담당자 입력"
                v-model="company.director"
              />
            </label>
          </input-form>

          <input-form class="grid-item" label="연락처">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="연락처 입력"
                v-model="company.phone"
              />
            </label>
          </input-form>
        </div>

<!--        <company-user-auth-module-->
<!--          v-if="getId"-->
<!--          title="업체 사용자 정보"-->
<!--          type="info"-->
<!--          popupTitle="회사 불러오기"-->
<!--          permissionHead="권한설정"-->
<!--          :colData="[-->
<!--            { head: '아이디', key: 'username' },-->
<!--            { head: '내국인/외국인', key: 'isforeign' },-->
<!--            { head: '직책', key: 'position' },-->
<!--            { head: '이름', key: 'name' },-->
<!--            { head: '직종', key: 'section' },-->
<!--            { head: '휴대폰번호', key: 'mobile' },-->
<!--            { head: '이메일', key: 'email' },-->
<!--          ]"-->
<!--          :numbering="true"-->
<!--          :users="memberList"-->
<!--          class="mt-28px"-->
<!--        />-->
      </div>

    </vs-card>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import HttpRequest from "@/util/HttpRequest";
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";
import AddressField from "@/components/AddressField.vue";
import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PopupCompanyInfo from "@/views/pages/standing-account/PopupCompanyInfo.vue";
import PopupSearchCompany from "@/popup/PopupSearchCompany.vue";
import CompanyUserAuthModule from "@/views/fields/components/CompanyUserAuthModule.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    CompanyUserAuthModule,
    PopupSearchCompany,
    PopupCompanyInfo,
    RadioGroup,
    InputForm,
    AddressField,
    SignField,
    FileUploader,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
    Multiselect
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  computed:{
    getId () {
      return this.$route.params.id
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    addressInfo: {
      get() {
        return {
          home_zip: this.company.com_address_zip,
          home_address_1: this.company.com_address,
          home_address_2: this.company.com_address_detail,
        }
      },
      set(value) {
        this.company.com_address_zip = value.home_zip;
        this.company.com_address = value.home_address_1;
        this.company.com_address_detail = value.home_address_2;
      }
    },
    businessNumberSuccess() {
      if (this.getId && this.company.com_number === this.originalCompany.com_number) {
        return false
      }

      if (this.isCheckedCompany && !this.isRegistCompany) {
        return true
      } else {
        return false
      }
    },
    businessNumberDanger() {
      if (this.getId && this.company.com_number === this.originalCompany.com_number) {
        return false
      }

      if (this.isCheckedCompany && this.isRegistCompany) {
        return true
      } else {
        return false
      }
    },
    editMode() {
      if (this.originCompanyString !== JSON.stringify(this.company)) {
        return true
      } else if (this.company.attachments && this.company.attachments.length > 0 && this.사업자등록증.id !== this.company.attachments[0].id) {
        return true
      } else {
        return false
      }
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
  },
  data() {
    return {
      fieldOptions: [],

      originCompanyString: "", // backup original company data
      originalCompany: {},
      company: {
        fields: [],
        com_name: "",
        com_type: "",
        com_ceo: "",
        com_number: "",
        com_address_zip: "",
        com_address: "",
        com_address_detail: "",
        com_business_class: "",
        com_business_type: "",
        director: "",
        phone: "",
        meta: {}
      },
      사업자등록증: {},
      memberList: [],

      error: {
        담당부서: "담당부서를 지정해주세요.",
        업체: ""
      },

      lastCheckedBusinessNumber: "",
      isCheckedCompany: false,
      isRegistCompany: false,
    };
  },
  async created() {
    await this.loadFieldList() // 사업장 목록 불러오기
    if (this.getId) {
      await this.loadCompany(this.getId) // 업체 정보 불러오기
      // await this.loadMember(this.getId) // 업체 사용자 정보 불러오기
    }
    /**
     * 2025-02-12 수정사항
     * 업체를 추가할 때에는, 모든 사업장에 참여시킨다
     */
    else {
      this.company.fields = this.fieldOptions.map((field) => {
        return {
          id: field.id,
          field_name: field.field_name,
        };
      });
    }
  },
  // input-icon-validate 클래스를 가진 엘리먼트에 대해 MutationObserver를 이용하여 자식 엘리먼트가 추가될 때마다 display: none 처리
  mounted() {
    this.$nextTick(() => {
      const iconElements = this.$el.querySelectorAll('.input-icon-validate');
      iconElements.forEach(iconElement => {
        iconElement.style.display = 'none';
      });

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('input-icon-validate')) {
                node.style.display = 'none';
              }
            });
          }
        });
      });

      observer.observe(this.$el, { childList: true, subtree: true });
    });
  },
  methods: {
    // 사업장명 검색
    async loadFieldList() {
      await HttpRequest.get('/api/v1/field/pub')
        .then(response => {
          if (response) {
            this.fieldOptions = response[0].fields.map((data) => {
              return {
                id: data.id,
                field_name: data.field_name,
              };
            });
          }
        }).catch(err => {
          console.log("err", err);
        });
    },

    onClickRemove() {
      console.log("onClickRemove")

      this.customConfirm("업체를 삭제하시겠습니까?", {
        confirmBtn: '삭제',
        cancelBtn: '취소',
        confirmFunction: async () => {
          await HttpRequest.delete(`/api/v1/company/${this.getId}`)
            .then(() => {
              this.$toast.success("삭제되었습니다.");
            })
            .catch(() => {
              this.$toast.error("삭제 중 오류가 발생했습니다.");
            });
          this.$router.push({
            name: 'page-company-management-list',
            query: this.$route.query
          });
        },
      });
    },
    onClickClose() {
      this.$router.push({
        name: 'page-company-management-list',
        query: this.$route.query
      });
    },
    async onClickCancel() {
      // 변경사항을 취소할 것인지 확인한다
      this.customConfirm("변경사항을 되돌리겠습니까?", {
        confirmBtn: '되돌리기',
        cancelBtn: '취소',
        confirmFunction: async () => {
          await this.loadCompany(this.getId) // 업체 정보 불러오기
          // await this.loadMember(this.getId) // 업체 사용자 정보 불러오기

          this.$toast.success("변경사항이 취소되었습니다.");
        },
      });
    },
    async onClickSave() {
      if (!this.validateForm()) return;

      const url = this.getId ? `/api/v1/company/${this.getId}` : `/api/v1/company`

      const option = {
        com_number: this.company.com_number,
        com_name: this.company.com_name,
        com_ceo: this.company.com_ceo,
        com_type: this.company.com_type,
        com_business_class: this.company.com_business_class,
        com_business_type: this.company.com_business_type,
        com_address_zip: this.company.com_address_zip,
        com_address: this.company.com_address,
        com_address_detail: this.company.com_address_detail,
        director: this.company.director,
        phone: this.company.phone,
        field_ids: this.company.fields.map((field) => field.id),
        project_ids: [this.projectId],
        parent_company_id: 917,
      };
      if (this.사업자등록증 && this.사업자등록증.id) {
        option.uploads = [this.사업자등록증.id];
      }

      this.loading(true);
      let isSuccess = false;
      try {
       await HttpRequest.post(url, option).then(() => {
          this.$toast.success("저장되었습니다.");
          isSuccess = true;
        });
      } catch (e) {
        this.$toast.error("저장 중 오류가 발생했습니다.");
      } finally {
        this.loading(false);
      }

      if (isSuccess) {
        this.$router.push({
          name: 'page-company-management-list',
          query: this.$route.query
        });
      }
    },

    validateForm() {
      if (this.company.fields.length === 0) {
        this.$toast.warning("사업장을 1개 이상 선택해주세요.");
        return false;
      }
      if (!this.company.com_name) {
        this.$toast.warning("업체명을 입력해주세요.");
        return false;
      }
      if (!this.company.com_number) {
        this.$toast.warning("사업자등록번호를 입력해주세요.");
        return false;
      }
      return true;
    },


    async loadCompany(id) {
      const response = await this.$store.dispatch("company/LOAD_COMPANY", { companyId: id, force: true });
      this.company = JSON.parse(JSON.stringify(response));

      this.company.address = {
        home_zip: this.company.com_address_zip,
        home_address_1: this.company.com_address,
        home_address_2: this.company.com_address_detail,
      }

      // this.company.attachments 배열 첫번째를 "사업자등록증"으로 설정
      this.사업자등록증적용(this.company.attachments);

      // 백업본 저장
      this.originCompanyString = JSON.stringify(this.company);
      this.originalCompany = JSON.parse(this.originCompanyString);
    },

    사업자등록증적용(attachments) {
      if (attachments && attachments.length > 0) {
        const attachment = attachments[0];
        this.사업자등록증 = {
          id: attachment.id,
          fileName: attachment.file_name,
          fileSize: attachment.file_size,
          path: attachment.path,
        }
      }
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 10000;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      this.memberList =  JSON.parse(JSON.stringify(this.$store.state.company.memberList));
      console.log("this.memberList", this.memberList)
    },

    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "업체관리",
          message: msg,
          cancelBtn: "확인",
          cancelFunction: () => this.$router.push({
            name: 'page-company-management-list',
            query: this.$route.query
          }),
        },
      });
      window.dispatchEvent(customAlert);
    },
    customConfirm(msg, options) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: options.title || "확인",
          message: msg,
          useConfirm: true,
          confirmBtn: options.confirmBtn || "확인",
          confirmFunction: options.confirmFunction,
          cancelBtn: options.cancelBtn || "닫기",
          cancelFunction: options.cancelFunction,
        },
      });
      window.dispatchEvent(customAlert);
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    formatBusinessNumber(value) {
      // 숫자와 하이픈만 입력 허용
      let formattedValue = value.replace(/[^0-9-]/g, '');

      // 하이픈 제거
      formattedValue = formattedValue.replace(/-/g, '');

      // 10자리 숫자인 경우에만 포맷팅
      if (formattedValue.length === 10) {
        formattedValue = formattedValue.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
      } else if (formattedValue.length > 10) {
        formattedValue = formattedValue.substring(0, 10);
      }

      // 최대 12자리(하이픈 포함)로 제한
      formattedValue = formattedValue.slice(0, 12);

      // 값 업데이트
      // this.사업자등록번호_검색 = formattedValue;
      this.$nextTick(() => {
        this.company.com_number = formattedValue;

        if (this.company.com_number.length === 12) {
          this.loadCompanyInfo()
        } else {
          this.isCheckedCompany = false
        }
      });
    },
    async loadCompanyInfo() {
      if (this.lastCheckedBusinessNumber === this.company.com_number) {
        return
      }
      this.lastCheckedBusinessNumber = this.company.com_number

      await HttpRequest.get('/api/v1/company/pub', {
        params: {
          bnum: this.company.com_number
        }
      })
        .then(response => {
          if (response) {
            if (response && response.data && response.data.length > 0) {
              this.isRegistCompany = true;
            } else {
              this.isRegistCompany = false;
            }

            this.isCheckedCompany = true
          }
        }).catch(err => {
          console.log("err", err);
        });
    },
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div { border-bottom: 1px solid #e0e0e0; }
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }


  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}

.grid-item {
  ::v-deep .con-text-validation {
    font-size: 12px;
  }
}

.align-center {
  align-items: center;
}
.success-color {
  color: #28C76F;
}
.alert-color {
  color: #EA5455;
}
.input-button {
  height: 37.5px
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}

.grid-item {
  align-self: start;
  grid-column: span 2;
}

@media (min-width: 768px) {
  .grid-item {
    align-self: start;
    grid-column: span 1;
  }
}

</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary), 1) !important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97);
    }
    border-color: #cdcdcd !important;
  }
}
</style>
